module.exports = __webpack_public_path__ + "media/badges/oli-juste-dates-520ec711.svg";